/* eslint-disable import/prefer-default-export */
import React from 'react';
import { defaultAutocompleteResultsObject } from './search';

export const WebviewContext = React.createContext(false);

export const SearchPageContext = React.createContext({
  pageType: '',
  resultType: '',
  searchQuery: '', // used in shop pages to redirect to search page
});

export const SearchBoxContext = React.createContext({
  submitSearchIsActive: false,
  setSubmitSearchIsActive: () => {},
  forceSearchSubmit: false,
  setForceSearchSubmit: () => {},
});

export const AutoCompleteContext = React.createContext({
  query: '',
  setQuery: () => {},
  preQueryOpen: false,
  setPreQueryOpen: () => {},
  autocompleteOpen: false,
  setAutocompleteOpen: () => {},
  autocompleteDisabled: false,
  setAutocompleteDisabled: () => {},
  autocompleteResults: defaultAutocompleteResultsObject,
  setAutocompleteResults: () => {},
  resetResults: () => {},
});

export const NavContext = React.createContext({
  searchIsActive: false,
  setSearchIsActive: () => {},
});

export const PaidLandingPageContext = React.createContext({
  redirectToPLP: false,
});

export const ShowAuditModeExpirationDateContext = React.createContext(true);
